export type NavType = {
  name: string;
  href: string;
};

export const Home: NavType = { name: "Home", href: "/" };
export const Services: NavType = { name: "Services", href: "/services" };
export const Insights: NavType = { name: "Insights", href: "/insights" };
export const AboutUs: NavType = { name: "About Us", href: "/about-us" };
export const ContactUs: NavType = {
  name: "Contact Us",
  href: "/contact-us",
};
export const PrivacyPolicy: NavType = {
  name: "Privacy Policy",
  href: `${AboutUs.href}/privacy-policy`,
};

// services
export const PersonalAndInHomeService: NavType = {
  name: "Personal & In-home care support",
  href: `${Services.href}/personal-and-in-home-care-support`,
};
export const SupportCoordinationService: NavType = {
  name: "Support coordination",
  href: `${Services.href}/support-coordination`,
};
export const CommunityEngagementService: NavType = {
  name: "Community engagement",
  href: `${Services.href}/community-engagement`,
};
export const AccommodationService: NavType = {
  name: "Accommodation & SIL",
  href: `${Services.href}/accommodation-supported-independent-living`,
};
export const TransportService: NavType = {
  name: "Transport",
  href: `${Services.href}/transport`,
};
export const PersonalAndInHomePricing = {
  name: "Pricing",
  href: `/price/personal-and-in-home-care-support`,
};
export const serviceLinks = [
  Services,
  PersonalAndInHomeService,
  // SupportCoordinationService,
  CommunityEngagementService,
  AccommodationService,
  TransportService,
  PersonalAndInHomePricing,
];

// about us
export const WhyIncluso = {
  name: "Why Incluso",
  href: `${AboutUs.href}/why-incluso`,
};
export const CustomerExperience = {
  name: "Customer experience",
  href: `${AboutUs.href}/customer-experience`,
};
export const OurTeam: NavType = {
  name: "Our team",
  href: `${AboutUs.href}/our-team`,
};
export const Career: NavType = {
  name: "Careers",
  href: `${AboutUs.href}/career`,
};
export const CommunityAndSustainability: NavType = {
  name: "Community and sustainability",
  href: `${AboutUs.href}/community-and-sustainability`,
};
export const Environmental: NavType = {
  name: "Environmental sustainability",
  href: `${AboutUs.href}/community-and-sustainability/environmental`,
};
export const Reconciliation: NavType = {
  name: "Reconciliation",
  href: `${AboutUs.href}/reconciliation`,
};
export const SocialResponsibility: NavType = {
  name: "Social responsibility",
  href: `${AboutUs.href}/community-and-sustainability/social`,
};
export const aboutUsLinks = [
  AboutUs,
  WhyIncluso,
  CustomerExperience,
  OurTeam,
  Career,
  CommunityAndSustainability,
  Environmental,
  Reconciliation,
  SocialResponsibility,
];

// contact us
export const Referral: NavType = {
  name: "Participant & referral intake",
  href: `${ContactUs.href}/referral`,
};
export const BookConsultation: NavType = {
  name: "Book a consultation",
  href: `${ContactUs.href}?state=calendar-booking`,
};
export const ContactForm: NavType = {
  name: "Feedback",
  href: `${ContactUs.href}?state=contact-form`,
};
export const contactUsLinks = [
  ContactUs,
  Referral,
  BookConsultation,
  ContactForm,
];

// sum
export const navOptions = {
  home: Home,
  services: Services,
  serviceslist: {
    personal: PersonalAndInHomeService,
    support: SupportCoordinationService,
    accommodation: AccommodationService,
    community: CommunityEngagementService,
    transport: TransportService,
  },
  pricing: { personal: PersonalAndInHomePricing },
  aboutUs: AboutUs,
  aboutUslist: {
    whyIncluso: WhyIncluso,
    customerExp: CustomerExperience,
    ourTeam: OurTeam,
    career: Career,
    community: CommunityAndSustainability,
    environmental: Environmental,
    social: SocialResponsibility,
    reconciliation: Reconciliation,
  },
  contactUs: ContactUs,
  contactUsList: {
    referral: Referral,
    bookConsultation: BookConsultation,
    feedback: ContactForm,
  },
  insights: Insights,
  privacyPolicy: PrivacyPolicy,
};

// price guide pdf
export const PriceGuide: NavType = {
  name: "NDIS Price Guide",
  href: "/files/NDIS Pricing Arrangements and Price Limits 2024-25 v1.3.pdf",
};
